import { fromJS } from 'immutable';

export default {
    setUserList: (state, users) => {
        return state.setIn(['list'], fromJS(users)).set('initialized', true);
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Users/core.js